import { useEffect } from 'react'
import { CheckoutStatus, getMerchantCheckoutPreselectExperiment } from '../../model'
import { useAllowedQuery, useCheckoutConsumerEmail, useCheckoutConsumerPhoneNumber, useExperimentTrigger, useIsTrustedCheckout } from '../../state'
import { useMonitoringWithEnduringEventProperties } from '../../integrations/monitoring'
import { isUndefinedOrEmpty } from '@afterpay/utils'
import { TrackingEvent } from '../../model/monitoring'
import { useXbtBrowserRedirect } from '../../utils/redirects'

export const useMerchantCheckoutPreselectExperiment = (checkoutButtonLabel?: string): void => {
  const trigger = useExperimentTrigger(getMerchantCheckoutPreselectExperiment(checkoutButtonLabel))

  useEffect(() => {
    trigger()
  }, [])
}

export const useTrustedCheckout = (): void => {
  const { logEvent } = useMonitoringWithEnduringEventProperties()
  const isTrustedCheckout = useIsTrustedCheckout()

  useEffect(() => {
    if (isTrustedCheckout) {
      logEvent('Checkout OAuth Logged In')
    }
  }, [isTrustedCheckout])
}

export const useInitLog = (status: CheckoutStatus, initialised: boolean, usernameFromCookie?: string): void => {
  const { logEvent } = useMonitoringWithEnduringEventProperties()
  const mobileFromMerchant = useCheckoutConsumerPhoneNumber()
  const emailFromMerchant = useCheckoutConsumerEmail()
  const { skipPrefill } = useAllowedQuery()

  useEffect(() => {
    if (status === CheckoutStatus.Loaded && initialised) {
      const isMobileProvided = !isUndefinedOrEmpty(mobileFromMerchant)
      const isEmailProvided = !isUndefinedOrEmpty(emailFromMerchant)

      logEvent(TrackingEvent.CHECKOUT_INITIATED, {
        isMobileProvided,
        isEmailProvided,
        isUserCookieProvided: !isUndefinedOrEmpty(usernameFromCookie),
        skipPrefill,
      })
    }
  }, [status, initialised])
}

export const useInitXbtBrowserRedirect = (redirectUrl: string): void => {
  const { logEvent } = useMonitoringWithEnduringEventProperties()
  const xbtBrowserRedirect = useXbtBrowserRedirect()

  useEffect(() => {
    if (redirectUrl) {
      logEvent(TrackingEvent.REDIRECT_CROSS_REGION)
      xbtBrowserRedirect(redirectUrl)
    }
  }, [redirectUrl])
}
